import { render } from "./MainLayout.vue?vue&type=template&id=5f05deda&scoped=true"
import script from "./MainLayout.vue?vue&type=script&lang=js"
export * from "./MainLayout.vue?vue&type=script&lang=js"

import "./MainLayout.vue?vue&type=style&index=0&id=5f05deda&scoped=true&lang=css"

import exportComponent from "/Users/macpc/Documents/WORK/project/Rail_transit_exper_mental_platform/源代码/实验综合平台/experimentalSynthesisUI/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f05deda"]])

export default __exports__